import React, { forwardRef, useRef } from 'react'

import Pressable from '../Pressable/Pressable'
import styles from './AddToCartIcon.module.css'
import cx from '../../../utils/className'

export const AddToCartBtn = forwardRef((props, ref) => {
  const atcIconRef = useRef()
  const currentRef = ref || atcIconRef

  const {
    className,
    iconClassName,
    handleClick,
    ariaLabel,
    ariaLabelledby,
    ...rest
  } = props

  const icon = (
    <span className={cx(styles.AddToCartIcon, iconClassName)} aria-hidden="true" />
  )

  if (handleClick) {
    return (
      <Pressable
        ref={currentRef}
        className={cx(styles.AddToCartBtn, className)}
        onClick={() => handleClick({ triggerRef: currentRef })}
        ariaLabel={ariaLabel}
        ariaLabelledby={ariaLabelledby}
        {...rest}
      >
        {icon}
      </Pressable>
    )
  }

  return (
    <div ref={currentRef} className={cx(styles.AddToCartBtn, className)} {...rest}>
      {icon}
    </div>
  )
})

AddToCartBtn.displayName = 'AddToCartBtn'